<template>
  <div
    class="profession-selector selector"
    :class="{
      missing: !classified.profession_id && (professionFocused || showWarnings),
    }"
  >
    <label for="profession"><strong>Profession concernée *</strong></label>
    <select
      name="profession"
      id="profession"
      v-model="classified.profession_id"
      @blur="professionFocused = true"
    >
      <option
        :value="profession.id"
        v-for="(profession, idx) in getSettings.professions"
        v-bind:key="idx"
      >
        {{ profession.name }}
      </option>
    </select>
    <div class="required" :if="!classified.profession">Champ non renseigné</div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "profession-selector",
  props: {
    showWarnings: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      professionFocused: false,
    };
  },
  computed: {
    ...mapState(["classified"]),
    ...mapGetters(["getSettings"]) ,
    profession: {
      get() {
        return this.classified.profession_id;
      },
      set(profession) {
        this.$store.commit("setProfession", profession);
      },
    },
  },
};
</script>
